export default {"src":"/_next/static/media/sfi.4e35fbac.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};